import { lastValueFrom } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root',
})
export class SystemStatusService {
    private domain: string;
    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    async getSystemStatusData() {
        return await lastValueFrom(
            this.http.get<any>(`${this.domain}/api/system-status`),
        );
    }

    getAlarmCounts(systemObject): number {
        let alarms = 0;

        if (_.isArray(systemObject)) {
            _.forEach(systemObject, (item) => {
                alarms += this.getAlarmCounts(item);
            });
        } else if (_.isObject(systemObject)) {
            _.forOwn(systemObject, (value, key) => {
                if (_.isArray(value) || _.isObject(value)) {
                    alarms += this.getAlarmCounts(value);
                } else if (value === 0) {
                    if (key !== 'timeout' && key !== 'active') {
                        if (
                            (systemObject as any).used === 0 &&
                            (systemObject as any).timeout === 0
                        ) {
                            alarms += 1;
                        } else {
                            alarms += 1;
                        }
                    }
                }
            });
        }

        return alarms;
    }
}
